import React, { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import InfiniteLoader from 'react-window-infinite-loader';
import ScrollToButton from '../ScrollToButton';
import TableRow from './TableRow';
import { TableContext } from './TableContext';

const offset = 10;

const InfiniteTableBase = props => {
  const { openRow, orderID, itemCount, isItemLoaded, loadMoreItems, items } = props;
  const listRef = React.createRef();
  const [visibleStart, setVisibleStart] = useState(1);
  const tableContextRef = useContext(TableContext);

  const scrollTo = () => {
    listRef.current.scrollToItem(0);
  };

  const toggleCheckboxSelectionHandler = item => {
    tableContextRef.toggleSelection(item);
  };

  useEffect(() => {
    tableContextRef.setDataProvider(items);
  }, [items]);

  useEffect(() => {
    if (listRef.current) scrollTo();
  }, [items[0]]);

  const row = useCallback(args => {
    const { index, style } = args;
    if (!isItemLoaded(index)) {
      return <InfiniteTable></InfiniteTable>;
    }
    const item = items[index];

    const handleOpenRow = itemId => {
      openRow(itemId);
    };

    return (
      <TableRow
        item={item}
        isFocused={orderID === item.id}
        onClick={() => handleOpenRow(item.id)}
        onCheckboxSelected={toggleCheckboxSelectionHandler}
        style={{
          ...style,
          marginLeft: isMobile ? 22 : 50,
          marginRight: isMobile ? 22 : 50,
          width: isMobile ? '89%' : 'calc(100% - 100px)',
          top: style.top + offset,
          height: style.height - offset
        }}
        index={index}
      />
    );
  });

  return (
    <InfiniteTable isMobile={isMobile}>
      <ScrollToButton
        style={{
          position: 'absolute',
          bottom: 12,
          right: 20,
          zIndex: 1
        }}
        onClick={scrollTo}
        start={visibleStart}
      />
      <div className="wrapper-div">
        <AutoSizer>
          {({ height, width }) => (
            <InfiniteLoader isItemLoaded={isItemLoaded} itemCount={itemCount} loadMoreItems={loadMoreItems}>
              {({ onItemsRendered }) => (
                <List
                  height={height}
                  itemCount={itemCount}
                  onItemsRendered={({ visibleStartIndex, visibleStopIndex }) => {
                    setVisibleStart(visibleStartIndex + 1);
                    return onItemsRendered({
                      visibleStartIndex,
                      visibleStopIndex
                    });
                  }}
                  itemSize={isMobile ? 260 : 100}
                  width={width}
                  ref={listRef}
                  className="table">
                  {row}
                </List>
              )}
            </InfiniteLoader>
          )}
        </AutoSizer>
      </div>
    </InfiniteTable>
  );
};

const InfiniteTable = styled.div`
  height: 90%;

  .wrapper-div {
    height: calc(100% - 83px);
    overflow-x: hidden;

    ${({ isMobile }) =>
      isMobile &&
      `
      height: 100%;
    `}
  }

  .table {
    width: 100%;
    height: 100%;
    &&& {
      margin: 0;
    }
  }
`;

export default InfiniteTableBase;
